import React, { useState , useEffect} from 'react';
import logo1 from '../assets/logo1.png';
import logo2 from '../assets/logo2.png';
import { Menu, X,} from 'lucide-react'
import { useNavigate } from "react-router-dom";

export default function Header(){
    const navigate = useNavigate();
      const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
      const [isMenuOpen, setIsMenuOpen] = useState(false);
      const [activeSection, setActiveSection] = useState('home');
      const [scrolled, setScrolled] = useState(false);
      const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
      
    
    const [hovered, setHovered] = useState(null); // "about" | "team" | "contact"
      const [flashPhase, setFlashPhase] = useState(null); // "blue" | "green" | "normal"
    
      const handleMouseEnter = (btn) => {
        setHovered(btn);
        setFlashPhase("blue");
        setTimeout(() => setFlashPhase("green"), 200); // 0.1 sec → green
      };
    
      const handleMouseLeave = (btn) => {
        setHovered(btn);
        
        setFlashPhase("blue");
        setTimeout(() => setFlashPhase("normal"), 200); // 0.1 sec → green
      
      }
    
      // Determine text color for each button
      const getColor = (btn) => {
        if (hovered === btn) {
          if (flashPhase === "blue") return "text-blue-600";
          if (flashPhase === "green") return "text-[#0BA36C]";
          if (flashPhase === "normal") return "text-black";
    
        }
        
      };

      const goToTeam = () => {
    navigate('/');
    setTimeout(() => {
scrollToSection('team');
}, 0);
  };
  const goToAbout = () => {
    navigate('/');
    setTimeout(() => {
    scrollToSection('about');
    }, 0);
    };
    const goToContact = () => {
    navigate('/contact');
    setTimeout(() => {
    scrollToSection('contact');
    }, 0);
    };
    
      useEffect(() => {
        const handleScroll = () => {
          setScrolled(window.scrollY > 50);
          
          const sections = ['home', 'about', 'team','stats', 'contact', 'loan', 'security', 'faq', 'whyus', 'contact', 't&c', 'none'];
          const current = sections.find(section => {
            const element = document.getElementById(section);
            if (element) {
              const rect = element.getBoundingClientRect();
              return rect.top <= 100 && rect.bottom >= 100;
            }
            return false;
          });
          if (current) setActiveSection(current);
        };
    
        const handleMouseMove = (e) => {
          setMousePosition({ x: e.clientX, y: e.clientY });
        };
    
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('mousemove', handleMouseMove);
        return () => {
          window.removeEventListener('scroll', handleScroll);
          window.removeEventListener('mousemove', handleMouseMove);
        };
      }, []);
    
      const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          setIsMenuOpen(false);
        }
      };
      const TopLine =( {colors =  "#FFFFFF"}) =>{
        return(
            <span
            style={{ color: colors }}
      className={`
        absolute left-0 right-0 mx-auto w-[25px] h-[2px]  rounded
        transition-all duration-300
        ${isMenuOpen 
          ? "translate-y-[0px] rotate-45" 
          : "translate-y-[-6px] rotate-0"
        }
      `}
    />
        );
      }

      const BottomLine =( {colors =  "#FFFFFF"}) =>{
        return(
            <span
            style={{ color: colors }}
      className={`
        absolute left-0 right-0 mx-auto w-[25px] h-[2px]  rounded
        transition-all duration-300
        ${isMenuOpen 
          ? "translate-y-[0px] -rotate-45" 
          : "translate-y-[6px] rotate-0"
        }
      `}
    />
        );
      }
    
    const ReapIcon = ({ src = logo1 , colors = "#FFFFFF" }) => {
      return (
        <
         
        >
         <div className="flex items-center gap-3"  onClick={() => navigate('/')}
>
            <img
              src={src}  // replace with your logo path
              alt="Reap Capital"
              className="w-14 h-auto"
            />
            <div className="text-black font-alton text-2xl font-normal leading-tight ">
              <div style={{ color: colors }}>Reap</div>

              <div style={{ color: colors }}>Capital</div>
            </div>
          </div>
        </>
      );
    };
     
    
    return(
      <>
       <style>{`
       @keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.98);
  }
  100% {
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}

.animate-slideDown {
  animation: slideDown 0.3s ease-out forwards;
}


       
      `}</style>
        <nav
  className={`
    fixed w-full flex justify-center 
    px-2 py-4 z-50 transition-all duration-300  backdrop-blur-sm sm:backdrop-blur-sm md:backdrop-blur-0 bg-white/0
  `}
>
  <div className="max-w-[1280px] w-full mx-auto px-4 sm:px-6 lg:px-8 z-50">
    <div className="flex justify-between items-center h-16">

            <div className="flex items-center space-x-2 cursor-pointer z-50" onClick={() => scrollToSection('home')}>
<ReapIcon 
  src={["home", "contact", "t&c"].includes(activeSection) ? logo1 : logo2}
  colors={["home", "contact", "t&c"].includes(activeSection) ? "#ffffffff" : "#000000"}
  onClick={() => scrollToSection('hero')}
/>

            </div>
      <div className="hidden md:flex bg-[#F0F0F0] pt-[4px] pr-[8px] pb-[4px] pl-[8px] rounded-[16px] flex items-center shadow-lg border-[4px] border-white backdrop-blur-md z-40">

      {/* ABOUT */}
      <button
        onMouseEnter={() => handleMouseEnter("about")}
        onMouseLeave={() =>handleMouseLeave("about")}
        onClick={goToAbout}
        className={`
          pt-[8px] pr-[24px] pb-[10px] pl-[24px]
          text-[16px] rounded-[10px] font-medium
          transition-all duration-100
          ${activeSection === "about" ?  "text-[#0BA36C] border border-[#0BA36C]" : "text-black"}
          ${getColor("about")}
        `}
      >
        About
      </button>

      {/* TEAM */}
      <button
        onMouseEnter={() => handleMouseEnter("team")}
        onMouseLeave={() =>handleMouseLeave("team")}
        onClick={goToTeam}
        className={`
          pt-[8px] pr-[24px] pb-[10px] pl-[24px]
          text-[16px] rounded-[10px] font-medium
          transition-all duration-300
          ${activeSection === "team" ? " text-[#0BA36C] border border-[#0BA36C]" : "text-black"}
          
          ${getColor("team")}
        `}
      >
        Team
      </button>

      {/* CONTACT */}
      <button
        onMouseEnter={() => handleMouseEnter("contact")}
        onMouseLeave={() =>handleMouseLeave}
        onClick={goToContact}
        className={`
          pt-[8px] pr-[24px] pb-[10px] pl-[24px]
          text-[16px] rounded-[10px] font-medium
          transition-all duration-100
          ${activeSection === "contact" ? "text-[#0BA36C] border border-[#0BA36C]" : "text-black"}
          
          ${getColor("contact")}
          
        `}
      >
        Contact
      </button>

    </div>
    <button
  onClick={() => setIsMenuOpen(!isMenuOpen)}
  className="md:hidden p-2 rounded-lg z-50"
>
 <div
  className={`
    relative w-[24px] h-[24px] transition-all duration-300
  `}
>
  {(() => {
const lineColor = ["home", "contact", "t&c"].includes(activeSection)
  ? "bg-white"
  : "bg-black";

    return (
      <>
        {/* Top Line */}
        <span
          className={`
            absolute left-0 right-0 mx-auto w-[25px] h-[2px] rounded
            transition-all duration-300
            ${lineColor}
            ${isMenuOpen 
              ? "translate-y-[0px] rotate-45" 
              : "translate-y-[-6px] rotate-0"
            }
          `}
        />

        {/* Bottom Line */}
        <span
          className={`
            absolute left-0 right-0 mx-auto w-[25px] h-[2px] rounded
            transition-all duration-300
            ${lineColor}
            ${isMenuOpen 
              ? "translate-y-[0px] -rotate-45" 
              : "translate-y-[6px] rotate-0"
            }
          `}
        />
      </>
    );
  })()}
</div>

</button>



          </div>
        </div>

    {isMenuOpen && (
  <div
    className="
      fixed inset-0 z-10  
     
      flex justify-center w-full
      transition-all duration-50
    "
    onClick={() => setIsMenuOpen(false)} // click outside closes menu
  >
    <div
      className="
         w-full 
        transition-all duration-500 
        animate-slideDown
      "
      onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
    >
<div className="w-full h-fit  inset-0 px-5 pt-24 pb-3 bg-white/10 backdrop-blur-lg transition-all duration-10">
      <div className="bg-[#e7e6e6]  rounded-3xl shadow-lg py-0 space-y-3 border border-black">
          <button          
            onClick={goToAbout}
            className="
              block w-full 
              text-[18px] text-black font-medium
              text-center py-3 rounded-lg
             
            "
          >
           About
          </button>
        
        <button          
            onClick={goToTeam}
            className="
              block w-full 
              text-[18px] text-black font-medium
              text-center py-3 rounded-lg
             
            "
          >
           Team
          </button>
          <button          
            onClick={goToContact}
            className="
              block w-full 
              text-[18px] text-black font-medium
              text-center py-3 rounded-lg
             
            "
          >
           Contact
          </button>
      </div>
      </div>
    </div>
  </div>
)}


      </nav>
      </>
    )
}